import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import PaymentScan from 'assets/images/payment-scan.svg';
import AppStore from 'assets/images/app-store-badge-us-black.svg';
import GooglePlay from 'assets/images/google-play-badge-us.svg';
import OntruckLogo from 'assets/icons/OntruckLogo';

const DownloadMobileApp = ({ className }) => {
  const { t } = useTranslation('DownloadMobileApp');

  return (
    <div className={className} data-testid="download-mobile-app">
      <div className="download-mobile-app">
        <div className="download-mobile-app__header">
          <OntruckLogo className="download-mobile-app__header__ontruck" />
          <img src={PaymentScan} alt="payment-scan" />
        </div>
        <h2>{t('downloadApp')}</h2>
        <p>
          {t('needDownload1')} <strong>{t('needDownload2')}</strong>
        </p>
        <p>{t('followingLinks')}</p>

        <div className="download-mobile-app__footer">
          <a
            className="download-mobile-app__footer__option"
            href="https://apps.apple.com/es/app/ontruck/id1145743408"
          >
            <img className="" src={AppStore} alt="app-store" />
          </a>
          <a
            className="download-mobile-app__footer__option"
            href="https://play.google.com/store/apps/details?id=drivers.ontruck.ontruck"
          >
            <img className="" src={GooglePlay} alt="google-play" />
          </a>
        </div>
      </div>
    </div>
  );
};

DownloadMobileApp.propTypes = {
  className: PropTypes.string,
};

export default DownloadMobileApp;
